var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagAndorra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_14852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 30.4124C11.147 31.4295 13.5068 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5068 0 11.147 0.5705 9.0435 1.58763L7.65219 16L9.0435 30.4124Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9561 30.4118C28.308 27.8239 31.9996 22.3433 31.9996 15.9999C31.9996 9.65664 28.308 4.17601 22.9561 1.58813V30.4118Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 30.4118V1.58813C3.69156 4.17601 0 9.65657 0 15.9999C0 22.3433 3.69156 27.8239 9.0435 30.4118Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5652C16 19.012 16 16 16 16H20.1739V18.0869C20.1739 18.4495 19.4783 19.778 17.7612 20.8696C17.1109 21.2831 16.4378 21.4161 16 21.5652Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8261 11.8262H16V16.0001H11.8261V11.8262Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 10.4348C18.0869 9.66633 17.464 9.04346 16.6956 9.04346C16.4419 9.04346 16.2048 9.11246 16 9.23108C15.7952 9.11246 15.5581 9.04346 15.3044 9.04346C14.536 9.04346 13.9131 9.66633 13.9131 10.4348H10.4348V17.3912C10.4348 19.981 12.4914 21.4786 14.1042 22.255C13.9836 22.4611 13.9131 22.7003 13.9131 22.9565C13.9131 23.725 14.536 24.3478 15.3044 24.3478C15.5581 24.3478 15.7952 24.2788 16 24.1602C16.2048 24.2788 16.4419 24.3478 16.6956 24.3478C17.464 24.3478 18.0869 23.725 18.0869 22.9565C18.0869 22.7003 18.0164 22.4611 17.8957 22.255C19.5085 21.4786 21.5652 19.981 21.5652 17.3912V10.4348H18.0869ZM19.4783 17.3912C19.4783 17.7538 19.4782 18.857 17.7612 19.9486C17.1109 20.3621 16.4377 20.6302 16 20.7793C15.5623 20.6302 14.8891 20.3621 14.2388 19.9486C12.5218 18.857 12.5218 17.7538 12.5218 17.3912V12.5217H19.4783V17.3912Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_14852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAndorra);
export default __webpack_public_path__ + "static/media/flag_andorra.d08b6e96d648e597731783e49fcdf40b.svg";
export { ForwardRef as ReactComponent };